export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategoryNav />
      <HotArticles />
      <LatestArticles />
      <NewsletterSection />
      <Footer />
    </div>
  );
}

import { articles, getHotArticles, getLatestArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';

function HeroSection() {
  const featuredArticle = articles[0];

  return (
    <section className="relative pt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-6 md:pt-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2">
            <ArticleCard article={featuredArticle} variant="featured" />
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2 pb-2 border-b border-secondary-200/60">
              <i className="ri-fire-line text-accent-500 text-lg"></i>
              <h2 className="text-sm font-bold font-heading text-foreground-900">24小时热榜</h2>
            </div>
            {getHotArticles().slice(0, 4).map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex items-start gap-3 cursor-pointer"
              >
                <span className="text-lg font-black font-heading text-primary-400 w-6 flex-shrink-0 leading-none mt-0.5">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1 text-xs text-secondary-400">
                    <span>{article.category}</span>
                    <span>{article.viewCount.toLocaleString()}阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CategoryNav() {
  return (
    <section className="py-10 md:py-12">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-xl`}></i>
              </div>
              <span className="text-sm font-bold font-heading text-foreground-800 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-secondary-400">{cat.articleCount}篇爆料</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function HotArticles() {
  const hotList = getHotArticles().slice(1);

  return (
    <section className="py-8 md:py-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5 md:mb-6">
          <div className="flex items-center gap-2">
            <i className="ri-fire-line text-primary-500 text-lg"></i>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
              热门爆料
            </h2>
          </div>
          <Link
            to="/category/yule"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotList.slice(0, 4).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestArticles() {
  const latest = getLatestArticles();

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5 md:mb-6">
          <div className="flex items-center gap-2">
            <i className="ri-timer-line text-primary-500 text-lg"></i>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
              最新爆料
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
          <div className="hidden lg:block">
            <div className="sticky top-20 rounded-xl bg-background-100 border border-secondary-200/60 p-4">
              <h3 className="text-sm font-bold font-heading text-foreground-900 mb-3 flex items-center gap-2">
                <i className="ri-flashlight-line text-accent-500"></i>
                独家深度
              </h3>
              <div className="flex flex-col gap-3">
                {articles.filter((a) => a.isExclusive).slice(0, 5).map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group flex gap-3 cursor-pointer"
                  >
                    <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0">
                      <h4 className="text-xs font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                        {article.title}
                      </h4>
                      <span className="text-[11px] text-secondary-400 mt-1 block">{article.publishDate}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('loading');
    setErrorMsg('');

    try {
      const form = formRef.current;
      if (!form) return;
      const formData = new FormData(form);
      const honeypot = formData.get('website_alt') as string;
      if (honeypot && honeypot.trim() !== '') {
        setStatus('success');
        setEmail('');
        return;
      }

      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt' || !(value as string).trim()) {
          body.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9qs1svnahb7382oveig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }

      if (!response.ok || parsed?.code !== 'OK') {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        throw new Error(serverMsg);
      }

      setStatus('success');
      setEmail('');
    } catch (err: any) {
      setStatus('error');
      setErrorMsg(err.message || '提交失败，请稍后再试');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-secondary-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-bold font-heading text-background-50 mb-2">
          不错过任何爆料
        </h2>
        <p className="text-sm text-secondary-400 mb-6 max-w-md mx-auto">
          订阅黑料舍，第一时间获取独家内幕和深度调查报道。
        </p>
        {status === 'success' ? (
          <p className="text-accent-400 font-medium text-sm">订阅成功！感谢你的关注。</p>
        ) : (
          <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto" data-readdy-form="">
            <div className="visually-hidden-field">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-4 py-2.5 text-sm rounded-lg bg-secondary-800 text-background-50 placeholder-secondary-500 border border-secondary-700 focus:outline-none focus:border-primary-500 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-red-400 text-xs mt-2">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}